import './i18nConfig';
import './index.css';
import AppRoot from './App.root';
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
    Component: AppRoot,
};
